import { Spinner } from '@heroui/react'

// Constants
const CONTAINER_STYLES =
  'w-80 h-40 flex items-center justify-center bg-default-50 rounded-lg'

// Interfaces
interface StateContainerProps {
  readonly children: React.ReactNode
  readonly className?: string
}

interface ErrorStateProps {
  readonly title: string
  readonly subtitle?: string
}

// Components
export const StateContainer = ({
  children,
  className = CONTAINER_STYLES,
}: StateContainerProps) => (
  <div className="w-full flex justify-center">
    <div className={className}>{children}</div>
  </div>
)

export const LoadingState = () => (
  <StateContainer>
    <Spinner size="lg" />
  </StateContainer>
)

export const ErrorState = ({ title, subtitle }: ErrorStateProps) => (
  <StateContainer>
    <div className="text-center">
      <p className="text-default-500">{title}</p>
      {subtitle && <p className="text-default-400 text-sm mt-1">{subtitle}</p>}
    </div>
  </StateContainer>
)
